import Vue from "vue";
import Router from "vue-router";
/* mainLayout */
import mainLayout from "@/layout/mainLayout";
import userLayout from "@/layout/userLayout";
Vue.use(Router);
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
         {
           path: "/",
           hiddren: true,
           redirect: "/login",
           // component: () => import('@/views/login/FactoryLogin'),
         },
         {
           path: "/login",
           hidden: true,
           component: userLayout,
           children: [
             {
               path: "",
               name: "login",
               component: () => import("@/views/login/Login"),
             },
           ],
         },

         {
           path: "/platform/home",
           hidden: true,
           component: () => import("@/platform/Home/Home"),
           redirect: "/platform/factories",
           children: [
             {
               path: "/platform/factories",
               component: () =>
                 import("@/platform/factory/factoryList/FactoryList"),
             },
             {
               path: "/platform/machines",
               component: () =>
                 import("@/platform/machine/machineList/MachineList"),
             },
             {
               path: "/platform/factories/callback",
               component: () =>
                 import("@/views/login/components/wxLogin/Callback"),
             },
             {
               path: "/platform/machines/iPCSimulation/:machineId",
               component: () =>
                 import("@/platform/machine/iPCSimulation/IPCSimulation"),
             },
             {
               path: "/platform/platformadmin",
               component: () =>
                 import("@/platform/platformAdmin/platformAdmin"),
             },
             {
               path: "/platform/personcentral",
               component: () => import("@/platform/central/personCentral"),
             },
           ],
         },

         {
           path: "/dashboard",
           component: mainLayout,
           redirect: "/dashboard",
           children: [
             //  {
             //    path: "",
             //    name: "Dashboard",
             //    // hidden: true,
             //    // component: () => import('@/views/machine/machinePreview/MachinePreview'),
             //    component: () => import("@/views/dashboard/index2"),
             //    meta: {
             //      title: "首页",
             //      icon: "iconfont icondashboard",
             //      affix: true,
             //    },
             //  },
             {
               path: "",
               name: "Dashboard",
               //  hidden: true,
               // component: () => import('@/views/machine/machinePreview/MachinePreview'),
               component: () => import("@/views/dashboard/index3"),
               meta: {
                 title: "首页",
                 icon: "iconfont icondashboard",
                 //  affix: true,
               },
             },
           ],
         },

         {
           path: "/machine",
           component: mainLayout,
           redirect: "/machine/machinePreview",
           name: "Machine",
           hidden: true,
           meta: {
             title: "机台管理",
             icon: "iconfont iconguanli1",
           },
           children: [
             {
               path: "machinePreview/machineDefectCount/:id",
               name: "machineDefectCount",
               hidden: true,
               component: () =>
                 import("@/views/machine/machineDefect/MachineDefect"),
               meta: {
                 title: "机台疵点",
               },
             },
             {
               path: "machinePreview/machineOrder/:id",
               name: "machineOrder",
               hidden: true,
               component: () =>
                 import("@/views/machine/machineOrder/MachineOrder"),
               meta: {
                 title: "机台工单",
               },
             },
           ],
         },

         {
           path: "/product",
           component: mainLayout,
           // hidden: true,
           redirect: "/product/productOrderList",
           name: "product",
           meta: {
             title: "生产管理",
             icon: "iconfont iconshengchanrenwudanguanli",
           },
           children: [
             //  {
             //    path: "machinePreview",
             //    name: "MachinePreview",
             //    component: () =>
             //      import("@/views/machine/machinePreview/MachinePreview"),
             //    //  import("@/views/dashboard/index3"),
             //    meta: {
             //      title: "机台预览",
             //      icon: "iconfont iconshebei1",
             //    },
             //  },
             //  {
             //    path: "machinePreview/machineChart/:number/:id/:kind",
             //    name: "MachineChart",
             //    hidden: true,
             //    component: () =>
             //      import(
             //        "@/views/machine/machinePreview/machineChart/MachineChart"
             //      ),
             //    meta: {
             //      title: "机台详情",
             //    },
             //  },
             //  假数据
             {
               path: "machinePreview",
               name: "MachinePreview",
               //  hidden: true,
               component: () =>
                 import("@/views/machine/machinePreviews/MachinePreview"),
               //  import("@/views/dashboard/index3"),
               meta: {
                 title: "机台预览",
                 icon: "iconfont iconshebei1",
               },
             },
             {
               path: "machinePreview/machineChart/:number/:id/:kind",
               name: "MachineChart",
               hidden: true,
               component: () =>
                 import(
                   "@/views/machine/machinePreviews/machineChart/MachineChart"
                 ),
               meta: {
                 title: "机台详情",
               },
             },

             // 织造工单 -- sta
             {
               path: "workOrder",
               name: "workOrderList",
               component: () =>
                 import("@/views/product/workOrder/workOrderList"),
               meta: {
                 // title: '工单列表',
                 title: "织造通知",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
             {
               path: "workOrder/workOrderAdd",
               name: "workOrderAdd",
               hidden: true,
               component: () =>
                 import("@/views/product/workOrder/workOrderAdd/WorkOrderAdd"),
               meta: {
                 title: "工单添加",
               },
             },

             {
               path: "workOrder/workOrderDetalis/:id",
               name: "workOrderDetalis",
               hidden: true,
               component: () =>
                 import(
                   "@/views/product/workOrder/workOrderDetalis/workOrderDetalis"
                 ),
               meta: {
                 title: "工单详情",
               },
             },

             {
               path: "workOrder/workOrderPrint/",
               name: "workOrderPrint",
               hidden: true,
               component: () =>
                 import(
                   "@/views/product/workOrder/workOrderDetalis/workOrderPrint"
                 ),
               meta: {
                 title: "工单详情(格式化打印)",
               },
             },
             // 整经工单 -- sta
             {
               path: "beamWarping",
               name: "beamWarpingList",
               component: () =>
                 import("@/views/product/beamWarping/beamWarpingList"),
               meta: {
                 // title: '工单列表',
                 title: "整经通知",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
             {
               path: "beamWarping/beamWarpingAdd",
               name: "beamWarpingAdd",
               hidden: true,
               component: () =>
                 import(
                   "@/views/product/beamWarping/beamWarpingAdd/beamWarpingAdd"
                 ),
               meta: {
                 title: "工单添加",
               },
             },

             {
               path: "beamWarping/beamWarpingDetalis/:id",
               name: "beamWarpingDetalis",
               hidden: true,
               component: () =>
                 import(
                   "@/views/product/beamWarping/beamWarpingDetalis/beamWarpingDetalis"
                 ),
               meta: {
                 title: "工单详情",
               },
             },

             {
               path: "beamWarping/beamWarpingPrint",
               name: "beamWarpingPrint",
               hidden: true,
               component: () =>
                 import(
                   "@/views/product/beamWarping/beamWarpingDetalis/beamWarpingPrint"
                 ),
               meta: {
                 title: "工单详情(格式化打印)",
               },
             },
             // 工单 -- end

             {
               path: "productOrderList",
               name: "productOrderList",
               hidden: true,
               component: () =>
                 import("@/views/product/productOrderList/ProductOrderList"),
               meta: {
                 title: "生产单列表",
                 icon: "iconfont iconguankongjilu",
               },
             },
             {
               path: "productOrderList/productOrderAdd",
               name: "productOrderAdd",
               hidden: true,
               component: () =>
                 import(
                   "@/views/product/productOrderList/productOrderAdd/ProductOrderAdd"
                 ),
               meta: {
                 title: "生产单添加",
               },
             },
             {
               path: "productOrderList/productOrderEdit/:id",
               name: "productOrderEdit",
               hidden: true,
               component: () =>
                 import(
                   "@/views/product/productOrderList/productOrderEdit/ProductOrderEdit"
                 ),
               meta: {
                 title: "生产单编辑",
               },
             },
             {
               path: "productOrderList/productOrderDetalis/:id",
               name: "productOrderData",
               hidden: true,
               component: () =>
                 import(
                   "@/views/product/productOrderList/productOrderDetalis/productOrderDetalis"
                 ),
               meta: {
                 title: "生产单详情",
               },
             },
             {
               path: "labelList",
               name: "labelList",
               component: () => import("@/views/product/labelList/LabelList"),
               meta: {
                 title: "落布标签",
                 icon: "iconfont iconjiean",
               },
             },
             {
               path: "tingcheList",
               name: "tingcheList",
               component: () => import("@/views/product/tingche/tingcheList"),
               meta: {
                 title: "停车痕",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
             {
               path: "defectList",
               name: "defectList",
               component: () => import("@/views/product/defect/DefectList"),
               meta: {
                 title: "疵点信息",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
           ],
         },

         {
           path: "/statistics",
           name: "statistics",
           component: mainLayout,
           meta: {
             title: "统计报表",
             icon: "iconfont icontubiaozhuxingtu",
           },
           children: [
             {
               path: "machine/count",
               name: "machineCount",
               component: () =>
                 import("@/views/statistics/machineCount/machineCount"),
               meta: {
                 title: "机台运营报表",
                 icon: "iconfont icontubiaozhuxingtu",
                 keepAlive: true,
               },
             },

             {
               path: "machine/runningRateCount",
               name: "machineRunning",
               component: () =>
                 import("@/views/statistics/runningRateCount/runningRateCount"),
               meta: {
                 title: "开机率报表",
                 icon: "iconfont icontubiaozhuxingtu",
                 keepAlive: true,
               },
             },
             
             {
               path: "machine/workerRateCount",
               name: "workerRateCount",
               component: () =>
                 import("@/views/statistics/workerRateCount/workerRateCount"),
               meta: {
                 title: "工人开机率报表",
                 icon: "iconfont icontubiaozhuxingtu",
                 keepAlive: true,
               },
             },
             
             {
               path: "machine/capacityCount",
               name: "machineCapacity",
               component: () =>
                 import("@/views/statistics/capacityCount/capacityCount"),
               meta: {
                 title: "产能报表",
                 icon: "iconfont icontubiaozhuxingtu",
                 keepAlive: true,
               },
             },

             {
               path: "dangChe/list",
               name: "dangCheList",
               component: () =>
                 import("@/views/statistics/dangCheCount/dangCheList"),
               meta: {
                 title: "挡车工考勤",
                 icon: "iconfont icontubiaozhuxingtu",
               },
             },
             {
               path: "panTou/list",
               name: "panTouList",
               component: () =>
                 import("@/views/statistics/panTouCount/panTouList"),
               meta: {
                 title: "盘头工考勤",
                 icon: "iconfont icontubiaozhuxingtu",
               },
             },
             {
               path: "chuanSha/list",
               name: "chuanShaList",
               component: () =>
                 import("@/views/statistics/chuanShaCount/chuanShaList"),
               meta: {
                 title: "穿纱工考勤",
                 icon: "iconfont icontubiaozhuxingtu",
               },
             },
             {
               path: "jiXiu/list",
               name: "jiXiuList",
               component: () =>
                 import("@/views/statistics/jiXiuCount/jiXiuList"),
               meta: {
                 title: "维修工考勤",
                 icon: "iconfont icontubiaozhuxingtu",
               },
             },
             {
               path: "workerMonthDetails/:role/:id/:time",
               name: "workerMonthDetails",
               hidden: true,
               // cy说保留旧的"工人月明细"，加个新文件 代替它。
               // component: () => import('@/views/statistics/workerMonthDetails/workerMonthDetailsCalendar'),
               component: () =>
                 import(
                   "@/views/statistics/workerMonthDetails/workerMonthDetails"
                 ),
               meta: {
                 title: "工人月明细",
                 icon: "iconfont icontubiaozhuxingtu",
               },
             },
             {
               path: "workerDetails/:role/:id/:time",
               name: "workerDetails",
               hidden: true,
               component: () =>
                 import("@/views/statistics/workerDetails/workerDetails"),
               meta: {
                 title: "工人日明细",
                 icon: "iconfont icontubiaozhuxingtu",
               },
             },
           ],
         },

         {
           path: "/wuliaodangan",
           name: "wuliaodangan",
           component: mainLayout,
           meta: {
             title: "物料档案",
             icon: "iconfont icontubiaozhuxingtu",
           },
           children: [
             // 胚布档案 -- sta
             {
               path: "peiBu",
               name: "peiBuList",
               component: () => import("@/views/wuliaodangan/peiBu/peiBuList"),
               meta: {
                 title: "胚布",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
             {
               path: "peiBu/peiBuAdd",
               name: "peiBuAdd",
               hidden: true,
               component: () =>
                 import("@/views/wuliaodangan/peiBu/peiBuAdd/peiBuAdd"),
               meta: {
                 title: "物料添加-胚布",
               },
             },
             {
               path: "peiBu/peiBuDetalis/:id",
               name: "peiBuDetalis",
               hidden: true,
               component: () =>
                 import("@/views/wuliaodangan/peiBu/peiBuDetalis/peiBuDetalis"),
               meta: {
                 title: "物料详情-胚布",
               },
             },
             // 胚布档案 -- end

             // 原料 -- sta
             {
               path: "yuanLiao",
               name: "yuanLiaoList",
               component: () =>
                 import("@/views/wuliaodangan/yuanLiao/yuanLiaoList"),
               meta: {
                 title: "原料",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
             {
               path: "yuanLiao/yuanLiaoAdd",
               name: "yuanLiaoAdd",
               hidden: true,
               component: () =>
                 import(
                   "@/views/wuliaodangan/yuanLiao/yuanLiaoAdd/yuanLiaoAdd"
                 ),
               meta: {
                 title: "物料添加-原料",
               },
             },
             {
               path: "yuanLiao/yuanLiaoDetalis/:id",
               name: "yuanLiaoDetalis",
               hidden: true,
               component: () =>
                 import(
                   "@/views/wuliaodangan/yuanLiao/yuanLiaoDetalis/yuanLiaoDetalis"
                 ),
               meta: {
                 title: "物料详情-原料",
               },
             },
           ],
         },

         {
           path: "/warehouse2",
           component: mainLayout,
           meta: {
             title: "仓库管理",
             icon: "iconfont iconzhongchengduchanpin",
           },
           children: [
             {
               path: "inventoryDetails",
               name: "inventoryDetails",
               component: () =>
                 import("@/views/warehouse2/inventoryDetails/inventoryDetails"),
               meta: {
                 title: "库存明细",
                 icon: "iconfont iconfengxianqingdan",
               },
             },

             {
               path: "positionDetalis",
               name: "positionDetalis",
               hidden: true, //此页面隐藏
               component: () =>
                 import("@/views/warehouse2/inventoryDetails/positionDetalis"),
               meta: {
                 title: "仓位库存明细",
                 icon: "iconfont iconfengxianqingdan",
               },
             },

             {
               path: "packageDetalis",
               name: "packageDetalis",
               hidden: true, //此页面隐藏
               component: () =>
                 import("@/views/warehouse2/inventoryDetails/packageDetalis"),
               meta: {
                 title: "包裹明细",
                 icon: "iconfont iconfengxianqingdan",
               },
             },

             {
               path: "materialDetails",
               name: "materialDetails",
               component: () =>
                 import("@/views/warehouse2/materialDetails/materialDetails"),
               meta: {
                 title: "物料明细",
                 icon: "iconfont iconfengxianqingdan",
               },
             },

             {
               path: "inventoryofmaterialDetails",
               name: "inventoryofmaterialDetails",
               hidden: true, //此页面隐藏
               component: () =>
                 import(
                   "@/views/warehouse2/materialDetails/inventoryofmaterialDetails"
                 ),
               meta: {
                 title: "物料库存明细",
                 icon: "iconfont iconfengxianqingdan",
               },
             },

             {
               path: "inWarehouseOrderList",
               name: "inWarehouseOrderList",
               component: () =>
                 import(
                   "@/views/warehouse2/inWarehouseOrderList/inWarehouseOrderList"
                 ),
               meta: {
                 title: "入库单列表",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
             {
               path: "inWarehouseAdd",
               name: "inWarehouseAdd",
               hidden: true,
               component: () =>
                 import("@/views/warehouse2/inWarehouseOrderList/add/add"),
               meta: {
                 title: "增加/修改入库单",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
             {
               path: "inWarehouseDetalis/:id",
               name: "inWarehouseDetalis",
               hidden: true,
               component: () =>
                 import(
                   "@/views/warehouse2/inWarehouseOrderList/detalis/detalis"
                 ),
               meta: {
                 title: "入库单详情",
                 icon: "iconfont iconfengxianqingdan",
               },
             },

             // 方案1：按仓位选择 --sta
             {
               path: "outWarehouseOrderList",
               name: "outWarehouseOrderList",
               component: () =>
                 import(
                   "@/views/warehouse2/outWarehouseOrderList/outWarehouseOrderList"
                 ),
               meta: {
                 title: "出库单列表(按仓位)",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
             {
               path: "outWarehouseAdd",
               name: "outWarehouseAdd",
               hidden: true,
               component: () =>
                 import("@/views/warehouse2/outWarehouseOrderList/add/add"),
               meta: {
                 title: "增加/修改出库单",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
             {
               path: "outWarehouseDetalis/:id",
               name: "outWarehouseDetalis",
               hidden: true,
               component: () =>
                 import(
                   "@/views/warehouse2/outWarehouseOrderList/detalis/detalis"
                 ),
               meta: {
                 title: "出库单详情",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
             // 方案1：按仓位选择 --end

             // 方案2：按物料选择 --sta
             {
               path: "outWarehouseOrderList2",
               name: "outWarehouseOrderList2",
               component: () =>
                 import(
                   "@/views/warehouse2/outWarehouseOrderList2/outWarehouseOrderList"
                 ),
               meta: {
                 title: "出库单列表(按物料)",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
             {
               path: "outWarehouseAdd2",
               name: "outWarehouseAdd2",
               hidden: true,
               component: () =>
                 import("@/views/warehouse2/outWarehouseOrderList2/add/add"),
               meta: {
                 title: "增加/修改出库单",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
             {
               path: "outWarehouseDetalis2/:id",
               name: "outWarehouseDetalis2",
               hidden: true,
               component: () =>
                 import(
                   "@/views/warehouse2/outWarehouseOrderList2/detalis/detalis"
                 ),
               meta: {
                 title: "出库单详情",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
             // 方案1：按物料选择 --end
             {
               path: "shipmentOrderList",
               name: "shipmentOrderList",
               component: () =>
                 import(
                   "@/views/warehouse2/shipmentOrderList/shipmentOrderList"
                 ),
               meta: {
                 title: "出货单列表",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
             {
               path: "shipmentOrderAdd",
               name: "shipmentOrderAdd",
               hidden: true,
               component: () =>
                 import("@/views/warehouse2/shipmentOrderList/add/add"),
               meta: {
                 title: "增加/修改出货单",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
             {
               path: "shipmentOrderDetalis/:id",
               name: "shipmentOrderDetalis",
               hidden: true,
               component: () =>
                 import("@/views/warehouse2/shipmentOrderList/detalis/detalis"),
               meta: {
                 title: "出货单详情",
                 icon: "iconfont iconfengxianqingdan",
               },
             },
             {
               path: "shipmentCount",
               name: "shipmentCount",
               component: () =>
                 import("@/views/warehouse2/shipmentCount/shipmentCount"),
               meta: {
                 title: "出货报表",
                 icon: "iconfont icontubiaozhuxingtu",
                 keepAlive: true,
               },
             },
             {
               path: "shipmentCountDetail",
               name: "shipmentCountDetail",
               hidden: true,
               component: () =>
                 import("@/views/warehouse2/shipmentCount/shipmentCountDetail"),
               meta: {
                 title: "出货明细",
                 icon: "iconfont icontubiaozhuxingtu",
                 keepAlive: true,
               },
             },
             {
               path: "shipmentCountDetailMore",
               name: "shipmentCountDetailMore",
               hidden: true,
               component: () =>
                 import(
                   "@/views/warehouse2/shipmentCount/shipmentCountDetailMore"
                 ),
               meta: {
                 title: "出货单明细",
                 icon: "iconfont icontubiaozhuxingtu",
                 keepAlive: true,
               },
             },
           ],
         },

         // {
         //     path: '/warehouse',
         //     component: mainLayout,
         //     redirect: '/warehouse/positionList',
         //     meta: {
         //         title: '仓库管理',
         //         icon: 'iconfont iconzhongchengduchanpin'
         //     },
         //     children: [{
         //             path: 'positionList',
         //             name: 'positionList',
         //             component: () => import('@/views/warehouse/positionList/positionList'),
         //             meta: {
         //                 title: '仓位列表',
         //                 icon: 'iconfont iconzhongchengduchanpin'
         //             }
         //         },
         //         // {
         //         //   path: 'recordList',
         //         //   name: 'recordList',
         //         //   component: () => import('@/views/warehouse/recordList/recordList'),
         //         //   meta: { title: '出入库记录', icon: 'iconfont iconzhongchengduchanpin' }
         //         // },
         //         {
         //             path: 'inWarehouseOrderList',
         //             name: 'inWarehouseOrderList',
         //             component: () => import('@/views/warehouse/inWarehouseOrderList/inWarehouseOrderList'),
         //             meta: {
         //                 title: '入库单列表',
         //                 icon: 'iconfont iconzhongchengduchanpin'
         //             }
         //         },
         //         {
         //             path: 'outWarehouseApplyOrderList',
         //             name: 'outWarehouseApplyOrderList',
         //             component: () => import(
         //                 '@/views/warehouse/outWarehouseApplyOrderList/outWarehouseApplyOrderList'),
         //             meta: {
         //                 title: '出库申请单列表',
         //                 icon: 'iconfont iconzhongchengduchanpin'
         //             }
         //         },
         //         {
         //             path: 'outWarehouseApplyOrderAdd',
         //             name: 'outWarehouseApplyOrderAdd',
         //             hidden: true,
         //             component: () => import(
         //                 '@/views/warehouse/outWarehouseApplyOrderList/outWarehouseApplyOrderAdd/outWarehouseApplyOrderAdd'
         //             ),
         //             meta: {
         //                 title: '创建出库申请单',
         //                 icon: 'iconfont iconzhongchengduchanpin'
         //             }
         //         },
         //         {
         //             path: 'outWarehouseOrderList',
         //             name: 'outWarehouseOrderList',
         //             component: () => import('@/views/warehouse/outWarehouseOrderList/outWarehouseOrderList'),
         //             meta: {
         //                 title: '出库单列表',
         //                 icon: 'iconfont iconzhongchengduchanpin'
         //             }
         //         },
         //         {
         //             path: 'reserveList',
         //             name: 'reserveList',
         //             component: () => import('@/views/warehouse/reserveList/reserveList'),
         //             meta: {
         //                 title: '库存列表',
         //                 icon: 'iconfont iconzhongchengduchanpin'
         //             }
         //         },
         //         {
         //             path: 'reserveDetails/:positionId/:productName/:doorWidth',
         //             name: 'reserveDetails',
         //             hidden: true,
         //             component: () => import('@/views/warehouse/reserveList/reserveDetails/reserveDetails'),
         //             meta: {
         //                 title: '库存详情',
         //                 icon: 'iconfont iconzhongchengduchanpin'
         //             }
         //         }
         //     ]
         // },

         {
           path: "/user",
           component: mainLayout,
           redirect: "/user/userList",
           name: "user",
           // hidden: true,
           meta: {
             title: "工厂建设",
             icon: "iconfont iconjiaoseguanli2",
           },
           children: [
             {
               path: "userList",
               name: "UserList",
               component: () => import("@/views/user/userList/UserList"),
               meta: {
                 title: "用户管理",
                 icon: "iconfont iconyonghu1",
               },
             },

             {
               path: "roleList",
               name: "roleList",
               component: () => import("@/views/user/role/RoleList"),
               meta: {
                 title: "角色管理",
                 icon: "iconfont iconjiaoseguanli2",
               },
             },

             {
               path: "machineList",
               name: "machineList",
               // hidden: true,
               component: () =>
                 import("@/views/machine/machineList/MachineList"),
               meta: {
                 // title: '机台列表',
                 title: "设备管理",
                 icon: "iconfont icontubiaozhizuomoban-151",
               },
             },

             {
               path: "warehouseConstruction",
               name: "warehouseConstruction",
               component: () =>
                 import(
                   "@/views/warehouse2/warehouseConstruction/warehouseConstructionList"
                 ),
               meta: {
                 title: "工厂建仓",
                 icon: "iconfont icontubiaozhizuomoban-151",
               },
             },
             {
               path: "warehouseConstructionAdd",
               name: "warehouseConstructionAdd",
               hidden: true,
               component: () =>
                 import("@/views/warehouse2/warehouseConstruction/add/add"),
               meta: {
                 title: "新增/修改仓库",
                 icon: "iconfont iconfengxianqingdan",
               },
             },

             {
               path: "warehouseConstructionDetalis/:id",
               name: "warehouseConstructionDetalis",
               hidden: true,
               component: () =>
                 import(
                   "@/views/warehouse2/warehouseConstruction/detalis/detalis"
                 ),
               meta: {
                 title: "查看仓库",
                 icon: "iconfont iconfengxianqingdan",
               },
             },

             {
               path: "msgList",
               name: "msgList",
               hidden: true,
               component: () =>
                 import("@/views/user/workerMsgList/workerMsgList"),
               meta: {
                 title: "工人短信接收列表",
                 icon: "iconfont iconyonghu1",
               },
             },
             {
               path: "otherDevice",
               name: "otherDevice",
               component: () => import("@/views/user/otherDevice/otherDevice"),
               meta: {
                 title: "其他设备",
                 icon: "iconfont icontubiaozhizuomoban-151",
               },
             },
             {
               path: "otherDeviceAdd",
               name: "otherDeviceAdd",
               hidden: true,
               component: () =>
                 import(
                   "@/views/user/otherDevice/otherDeviceAdd/otherDeviceAdd"
                 ),
               meta: {
                 title: "添加其他设备",
               },
             },
           ],
         },

         {
           path: "/imitate",
           component: mainLayout,
           redirect: "/imitate/iPCSimulation",
           name: "imitate",
           hidden: true,
           meta: {
             title: "模拟管理",
             icon: "iconfont iconweiwangguanicon-defuben-",
           },
           children: [
             {
               path: "testPath",
               name: "testPath",
               // hidden: true,
               component: () => import("@/views/testPath"),
               meta: {
                 title: "测试",
                 icon: "iconfont iconweiwangguanicon-defuben-",
               },
             },
           ],
         },

         {
           path: "*",
           name: "testPath",
           component: () => import("@/views/error-page/404.vue"),
         },

         {
           path: "/central",
           component: mainLayout,
           // hidden: true,
           redirect: "/central/usercentral",
           name: "central",
           meta: {
             title: "个人中心",
             icon: "iconfont iconjiaoseguanli2",
           },
           children: [
             {
               path: "usercentral",
               name: "Usercentral",
               component: () => import("@/views/central/UserCentral"),
               meta: {
                 title: "个人中心",
                 icon: "iconfont iconjiaoseguanli2",
               },
             },
             {
               path: "usercentral/callback",
               hidden: true,
               component: () =>
                 import("@/views/login/components/wxLogin/Callback"),
             },
           ],
         },

         {
           path: "/statistics/workerCountBatchPrint/:role/:time",
           component: () =>
             import(
               "@/views/statistics/workerCountBatchPrint/workerCountBatchPrint"
             ),
           hidden: true,
         },
         {
           path: "/product/productOrderPrint/:id",
           component: () =>
             import(
               "@/views/product/productOrderList/productOrderPrint/ProductOrderPrint"
             ),
           hidden: true,
         },
         {
           path: "/warehouse/outWarehouseApplyOrderPrint/:id",
           component: () =>
             import(
               "@/views/warehouse/outWarehouseApplyOrderList/outWarehouseOrderPrint/OutWarehouseOrderPrint"
             ),
           hidden: true,
         },
       ];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // to 将要访问的路径
  // from 代表是从哪个路径跳转而来
  // next 是一个函数，表示放行
  // next() 放行 next('/login') 强制跳转
  if (to.path === "/" || to.path === "/login") return next();
  // 获取token
  const toakenStr = window.sessionStorage.getItem("token");
  if (!toakenStr) return next("/");
  next();
});

// const originalPush = Router.prototype.push
// Router.prototype.push = function push (location) {
//   return originalPush.call(this, location).catch(err => err)
// }

export default router;
